<template lang="">
    <span>
        <b-img v-if='isPrivate' src="/assets/images/private.png" width="50px" height="50px"  alt="private"
            title="Only members can see project forum and resources. No data will be accessible to the public."></b-img>
        <b-img v-else src="/assets/images/public.png" width="50px" height="50px"  alt="public"
            title="Everyone, including non-members, can see project information: including forum and resources. Any data accessible to project members, will be accessible to the public. Specific data can be made private via other settings."></b-img>
    </span>
</template>

<script>
export default {
    props: {
        isPrivate: {
            required: true,
            type: Boolean,
        }
    }
}
</script>

<style lang="">
    
</style>
